import React from 'react'
import { FormatDateOptions, defineMessages, useIntl } from 'react-intl'
import { Order as OrderModel } from 'msp-integrations'

const translations = defineMessages({
  deliveryTime: {
    defaultMessage: 'Delivery time: {deliveryTime}',
    id: 'msp.account.order_history.order_delivery.delivery_time'
  },
  estimatedDeliveryDate: {
    defaultMessage: 'Estimated delivery: {estimatedDeliveryDate}',
    id: 'msp.account.order_history.order_delivery.estimated_delivery_date'
  },
  deliveryTimeUnknow: {
    defaultMessage: 'Delivery time: unknown',
    id: 'msp.account.order_history.order_delivery.delivery_unknown'
  }
})

type OrderDeliveryDateProps = {
  order: OrderModel
  className?: string
}

const OrderDeliveryDate = ({
  order,
  className = ''
}: OrderDeliveryDateProps) => {
  const { formatMessage, formatDate } = useIntl()
  const shipment = order.getShipment()
  const dateFormattingOpts = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  } as FormatDateOptions

  return (
    <>
      {shipment && (
        <div
          className={`font-Roboto leading-12 text-14 text-accentGreen font-bold ${className}`}
        >
          {shipment.c_dhl_date && (
            <p>
              {formatMessage(translations.estimatedDeliveryDate, {
                estimatedDeliveryDate: formatDate(
                  shipment.c_dhl_date,
                  dateFormattingOpts
                )
              })}
            </p>
          )}

          {shipment.c_estimatedArrivalTime && (
            <p>
              {formatMessage(translations.deliveryTime, {
                deliveryTime: shipment.c_estimatedArrivalTime
              })}
            </p>
          )}

          {!shipment.c_dhl_date && !shipment.c_estimatedArrivalTime && (
            <p>{formatMessage(translations.deliveryTimeUnknow)}</p>
          )}
        </div>
      )}
    </>
  )
}

export default OrderDeliveryDate
